import * as React from 'react';
import './order-detail.scss';
import { Modal } from 'components/modal/modal';
import { digitSperator } from 'core/utils/decimalExtentions';
import { Badge } from 'components/badge/badge';
import moment from 'jalali-moment';
import { Spin, Tag } from 'antd';
import { getOrderDetailByTrackingCode } from '../../../../../core/repositories/orders-transactions';
import { copyToClipboard } from '../../../../../core/utils/copyToClipboard';
import { CopyOutlined } from '@ant-design/icons';
import Countdown from 'antd/lib/statistic/Countdown';
import { getOrderDetailById } from 'core/repositories/orders';
import { Order } from 'core/domain/order/order';
import { getIconPath } from 'core/utils/getIconPath';

interface Props {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    id?: string;
    trackingId?: string;
    selectedRow?: any;
}

export const OrderDetailModal: React.FC<Props> = ({ isOpen, setIsOpen, id, trackingId, selectedRow }) => {
    const [timer, setTimer] = React.useState<any>(0);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [order, setOrder] = React.useState<Order>();

    const fetchOrderDetailById = async () => {
        if (isOpen == true) await getOrderDetailById(setLoading, setOrder, setTimer, id);
    };

    const fetchOrderDetailByTrackingCode = async () => {
        if (isOpen == true) await getOrderDetailByTrackingCode(setLoading, setOrder, setTimer, trackingId);
    };

    React.useEffect(() => {
        fetchOrderDetailById();
    }, [isOpen]);

    React.useEffect(() => {
        if (selectedRow) fetchOrderDetailByTrackingCode();
    }, [selectedRow]);

    return (
        <Modal className="pmx-order-detail" isOpen={isOpen} setIsOpen={setIsOpen}>
            {loading ? (
                <Spin spinning={loading} />
            ) : (
                order && (
                    <>
                        <h3>جزئیات سفارش</h3>
                        <div className="row">
                            <span>کد پیگیری</span>
                            <p className=" en">
                                {order?.trackingCode}

                                <CopyOutlined onClick={() => copyToClipboard(order?.trackingCode, 'کد پیگیری')} />
                            </p>
                        </div>
                        <div className="row">
                            <span>جفت ارز</span>
                            <div className="cell pair">
                                <img src={getIconPath(order.pair.base.toLowerCase())} />
                                <span className="en">{order.pair.base}</span>
                                {` `} / {` `}
                                <span className="en">{order.pair.quote}</span>
                                <img src={getIconPath(order.pair.quote.toLowerCase())} />
                            </div>
                        </div>
                        <div className="row">
                            <span>مقدار مبدا</span>
                            <p>{digitSperator(order?.sourceQuantity)}</p>
                        </div>
                        <div className="row">
                            <span>مقدار مقصد</span>
                            <p>
                                {order?.pair?.quote === 'IRT'
                                    ? digitSperator(order?.destinationQuantity)
                                    : order?.destinationQuantity}
                            </p>
                        </div>

                        <div className="row">
                            <span>نوع سفارش</span>
                            <Tag color={`${order.side.id === 1 ? 'green' : 'red'}`}>{order.side.title}</Tag>
                        </div>

                        {order.createdBy && (
                            <div className="row">
                                <span>نام کامل کاربر</span>
                                <p>{order.createdBy}</p>
                            </div>
                        )}

                        <div className="row">
                            <span>تاریخ و زمان سفارش</span>
                            <p>
                                {moment.utc(order?.createdOn).local().locale('fa').format('YYYY/MM/DD')} |{' '}
                                {moment.utc(order?.createdOn).local().locale('fa').format('HH:mm')}
                            </p>
                        </div>

                        {order.onPrice && (
                            <div className="row">
                                <span>قیمت واحد (تومان)</span>
                                <p>{digitSperator(order.onPrice)}</p>
                            </div>
                        )}
                        {order.user && (
                            <div className="row">
                                <span>نام و نام خانوادگی</span>
                                <p>
                                    {order.user.firstName} {order.user.lastName}
                                </p>
                            </div>
                        )}

                        {order.user && (
                            <div className="row">
                                <span>شماره تماس</span>
                                <p>{order.user.userName}</p>
                            </div>
                        )}

                        {order.commission && (
                            <div className="row">
                                <span>کارمزد</span>
                                <p>{digitSperator(order.commission)} تومان</p>
                            </div>
                        )}

                        <div className="row">
                            <span>وضعیت</span>
                            <p>
                                <Badge
                                    text={order.state.id == 3 ? 'موفق' : order.state.title}
                                    type={
                                        order.state.id == 3
                                            ? 'success'
                                            : order.state.id == 4 || order.state.id == 5 || order.state.id == 2
                                              ? 'error'
                                              : 'waiting'
                                    }
                                    // icon={`/assets/icons/table/${
                                    //     row.state.id == 3
                                    //         ? "success"
                                    //         : row.state.id == 4 || row.state.id == 5 || row.state.id == 2
                                    //             ? "danger"
                                    //             : "waiting"
                                    // }.svg`}
                                />
                            </p>
                        </div>
                    </>
                )
            )}
        </Modal>
    );
};
